import { Plugin } from '../entities/plugin'
import type { GraphEvent } from '../types'
import type { TreeGraph, TreeNode } from '../graphs'

export interface ExpandCollapseOptions {
  trigger?: 'click' | 'dblclick'
  target?: string
}

const isEventMatched = (
  evt: GraphEvent,
  { trigger, target }: ExpandCollapseOptions
) => {
  const item = evt.item as TreeNode
  const { originalEvent } = evt
  const evtTarget = originalEvent?.target as HTMLElement

  return (
    trigger === originalEvent?.type &&
    (!target || item.element?.querySelector(target)?.contains(evtTarget))
  )
}

export const ExpandCollapsePlugin = Plugin.create<ExpandCollapseOptions>({
  name: 'expandCollapse',
  addOptions() {
    return {
      trigger: 'click',
    }
  },
  onNodeClick(evt: GraphEvent, graph) {
    if (isEventMatched(evt, this.options)) {
      ;(graph as TreeGraph).toggleNodeCollapse(evt.item as TreeNode)
    }
  },
  onNodeDoubleClick(evt, graph) {
    if (isEventMatched(evt, this.options)) {
      ;(graph as TreeGraph).toggleNodeCollapse(evt.item as TreeNode)
    }
  },
})
